import React, { useEffect } from 'react';
import validator from 'validator';
import './ValidatedDecimalInput.css';

const isValidDecimal = (raw) => {
  const s = String(raw ?? '').trim();
  if (s === '') return true;
  if (s.startsWith('-')) return false;
  return validator.isDecimal(s, { decimal_digits: '0,' });
};

function ValidatedDecimalInput({ name, value, onChange, editable, unit, onValidityChange }) {
  const isValid = isValidDecimal(value);

  useEffect(() => {
    if (onValidityChange) {
      onValidityChange(name, !editable || isValid);
    }
  }, [editable, isValid, name, onValidityChange]);

  return (
    <div className='validated-decimal-input-wrapper'>
      <div className='validated-decimal-input-row'>
        <input
          className={editable ? `edit-input${isValid ? '' : ' input-invalid'}` : 'project-detail-input'}
          disabled={!editable}
          name={name}
          value={value}
          onChange={onChange}
        />
        {unit ? <span className='unit-label'>{unit}</span> : null}
      </div>
      {editable && !isValid ? (
        <span className='input-invalid-hint red'>Enter a decimal number, e.g. 0.35</span>
      ) : null}
    </div>
  );
}

export default ValidatedDecimalInput;
